import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressModels } from '../../../../../models/address.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class AddressApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'addresses');
  }

  getCities(
    zipCode: string,
    repo: AddressModels.CitiesRepositoryEnum,
  ): Observable<AddressModels.City[]> {
    return this.post<AddressModels.City[]>('/cities', {
      postalCode: zipCode,
      citiesRepository: repo,
    });
  }
}

@Injectable({ providedIn: 'root' })
export class ReceiptApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'receipts');
  }

  export(params: any) {
    return this.httpClient.get(
      `${this.config.apiRootUrl}/${this.controllerName}/rejects/`,
      {
        params: params,
        responseType: 'blob',
      },
    );
  }
}
